define(function() {
    var IpsModelCollection = require('civicsBase/ipsModelCollection');
	const theModel = require('civicsModels/violation_code_model');

    return IpsModelCollection.extend({
		model: theModel,
        urlRoot: '/delegate/civics-api/api/cdr/setup/{0}/violationcode/inspectionType/{1}',
		url: function() {
			return this.urlRoot.format(this.type, this.id);
		}
    });
});
